export const CheckedIcon = ({
  className = 'w-5 h-5',
}: {
  className: string;
}) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 10c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M13.75 6.875l-5.25 6.25-2.25-2.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
